import React, { ReactElement, useState, useRef, useEffect } from 'react';
import classNames from 'classnames';

import styles from './TextContent.module.scss';

interface IProps {
  text: string,
  needShowMore?: boolean,
  heightBlock?: number,
  desktop?: boolean,
  classes?: string,
}

export const TextBlock = ({
  text,
  needShowMore = false,
  desktop = false,
  heightBlock = 170,
  classes = ''
}: IProps): ReactElement => {
  const [isShowMore, setShowMore] = useState(false);
  const [isHiddenText, setHiddenText] = useState(false);
  const textRef = useRef(null);
  useEffect(() => {
    const { height } = textRef.current.getBoundingClientRect();
    if (height > heightBlock) {
      setHiddenText(true);
    }
  }, []);

  const toggleShowMore = () => {
    setShowMore(!isShowMore);
    textRef.current.scrollIntoView({
      block: 'center',
      behavior: 'smooth',
    });
  };

  return (
    <>
      <section
        ref={textRef}
        className={classNames([styles.content, (needShowMore && !isShowMore && isHiddenText) && styles.showMore,
          desktop && styles.desktop, classes && classes])}
        style={desktop && !isShowMore && isHiddenText ? { height: heightBlock } : null}
        dangerouslySetInnerHTML={{ __html: text }}
      />
      {(needShowMore && isHiddenText) &&
        <button
          className={classNames([styles.button, desktop && styles.buttonDeskTop])}
          onClick={() => toggleShowMore()}>
          <svg
            className={classNames([isShowMore && styles.rotate])}
            width="8"
            height="9"
            viewBox="0 0 8 9"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path d="M3.64645 8.35355C3.84171 8.54882 4.15829 8.54882 4.35355 8.35355L7.53553
                      5.17157C7.7308 4.97631 7.7308 4.65973 7.53553 4.46447C7.34027 4.2692 7.02369 4.2692
                      6.82843 4.46447L4 7.29289L1.17157 4.46447C0.976311 4.2692 0.659728 4.2692 0.464466
                      4.46447C0.269204 4.65973 0.269204 4.97631 0.464466 5.17157L3.64645 8.35355ZM3.5
                      -2.18558e-08L3.5 8L4.5 8L4.5 2.18558e-08L3.5 -2.18558e-08Z"
            fill="#FF5524"/>
          </svg>
        </button>
      }
    </>
  );
};
